import React, { Component } from "react";
import { connect } from "react-redux";

//MUI
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

function mapStateToProps(state) {
  return {
    state
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

//Styles
const styles = theme => ({
  root: {}
});

class TypeLogs extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography>logs by type</Typography>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(TypeLogs));



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/log_tabs/TypeLogs.js